<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <div class="card">
            <h5 *ngIf="!objeto.id">Nuevo Contacto</h5>
            <h5 *ngIf="objeto.id">Contacto: {{ objeto.nombre }}</h5>
            <app-cabecera-ventana *ngIf="!loading" 
                [modulo]="modulo" [codigoRegistro]="codigoRegistro" [readonly]="isReadonly()" [esNuevo]="esNuevo()" [activo]="objeto?.activo"
                [cargando]="cargando"
                (eVolver)="volver()" (eNuevo)="nuevo()" (eEditar)="editar()" (eGuardar)="guardar()" (eEliminar)="eliminar()" (eInactivar)="inactivar($event)">
            </app-cabecera-ventana>
            <div *ngIf="loading" class="flex justify-content-center flex-wrap">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <form *ngIf="!loading" [formGroup]="formGroup">
                <p-tabView>
                    <p-tabPanel header="General">
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-1">
                                <label htmlFor="id">ID</label>
                                <p-inputNumber inputId="id" formControlName="id" readonly="true"></p-inputNumber>
                            </div>
                            <ng-container *ngIf="currentUser.superusuario">
                                <div class="field col-12 md:col-1">
                                    <label htmlFor="id_empresa">Empresa</label>
                                    <span class="p-input-icon-right">
                                        <input pInputText id="id_empresa" type="text" formControlName="id_empresa" (change)="onEmpresa()" (keydown.control.enter)="!isReadonly() ? onListaEmpresa() : ''" [readOnly]="isReadonly()" />
                                        <i *ngIf="!isReadonly()" style="font-size: 1.2rem;" class="pi pi-search" (click)="onListaEmpresa()"></i>
                                    </span>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="nombre_empresa">Descripción</label>
                                    <input pInputText id="nombre_empresa" type="text" formControlName="nombre_empresa" readonly />
                                </div>
                            </ng-container>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="nombre">Nombre</label>
                                <input pInputText id="nombre" type="text" formControlName="nombre" [readOnly]="isReadonly()" />
                                <small *ngIf="invalidControl('nombre')" style="color: red;">Este campo es requerido.</small>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="documento">Documento</label>
                                <input pInputText id="documento" type="text" formControlName="documento" [readOnly]="isReadonly()" />
                                <small *ngIf="invalidControl('documento')" style="color: red;">Este campo es requerido.</small>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="celular">Celular</label>
                                <!-- <input pInputText id="celular" type="text" formControlName="celular" [readOnly]="isReadonly()" /> -->
                                <p-inputMask id="celular" mask="9999-999-999" unmask="true" formControlName="celular" [readonly]="isReadonly()"></p-inputMask>
                                <small *ngIf="invalidControl('celular')" style="color: red;">Este campo es requerido.</small>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="correo">Correo</label>
                                <input pInputText id="correo" type="text" formControlName="correo" [readOnly]="isReadonly()" />
                                <small *ngIf="invalidControl('correo')" style="color: red;">Este campo es requerido.</small>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="col-12 md:col-4">
                                <div class="field-checkbox">
                                    <p-checkbox name="activo" id="activo" [binary]="true" formControlName="activo" readonly="true"></p-checkbox>
                                    <label for="activo">Activo</label>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="Auditoria">
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="nombre_creado_por">Creado por</label>
                                <input pInputText id="cod_creado_por" type="text" formControlName="cod_creado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_creacion">Fecha Creación</label>
                                <p-calendar id="fecha_creacion" formControlName="fecha_creacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="cod_actualizado_por">Actualizado por</label>
                                <input pInputText id="cod_actualizado_por" type="text" formControlName="cod_actualizado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_actualizacion">Fecha Actualización</label>
                                <p-calendar id="fecha_actualizacion" formControlName="fecha_actualizacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="cod_inactivado_por">Inactivado por</label>
                                <input pInputText id="cod_inactivado_por" type="text" formControlName="cod_inactivado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_inactivacion">Fecha Inactivación</label>
                                <p-calendar id="fecha_inactivacion" formControlName="fecha_inactivacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </form>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
    (close)="cerrarOnLista($event)">
</app-on-lista>
